import React from "react";
import { ErrorMessage } from "formik";
import { CiSearch } from "react-icons/ci";
import styles from "./custominput.module.css";

const CustomSearch = ({
  formType = "outline",
  isRequried = false,
  name,
  passwordToggle,
  placeholder,
  validate = true,
  ...rest
}) => {
  return (
    <>
      {formType === "outline" ? (
        <div className={styles.inputWrapper}>

          <div className={`has-pwd-icon ${passwordToggle ? "relative" : ""}`}>
            <div className="absolute inset-y-0 right-0 flex items-cener pr-2">
              <CiSearch />
            </div>

            <input
              type="text"
              name={name}
              id={name}
              placeholder={placeholder ? placeholder : ""}
              className={styles.textInput}
              {...rest}
            />
          </div>
          {validate && (
            <ErrorMessage
              name={name}
              component="div"
              className="text-red-500 text-[1.2rem] my-3"
            />
          )}
        </div>
      ) : (
        <div className={styles.fillInputWrapper}>

          <div className={`relative`}>
            <div className="absolute inset-y-0 left-0 flex items-center pl-4">
              <CiSearch size="2.5rem" className="text-gray" />
            </div>
            <input
              type="text"
              name={name}
              id={name}
              placeholder={placeholder ? placeholder : ""}
              className={styles.fillSearchInput}
              {...rest}
            />
          </div>
          {validate && (
            <ErrorMessage
              name={name}
              component="div"
              className="text-red-500 text-[1.2rem] my-3"
            />
          )}
        </div>
      )}
    </>
  );
};

export default CustomSearch;
